var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _g, _g2, _g3, _path44, _g4, _g5, _path45, _path46, _g6, _path47, _g7, _g8, _g9, _path48, _g10, _path49, _g11, _path50, _g12, _g13, _path51;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaveMountainComplex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 4000 445",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.5 264.18l19.54-13.68 17.59-14.66h19.54l19.55-1.95 13.68-7.82 36.16 7.82 15.63-1.96 22.48-9.77 16.61-12.7 22.47 4.88 16.62-7.81 26.38 27.36 20.52 20.52 32.25 12.7 7.82 8.8 19.54 14.66 2.93 8.79-329.31-35.18z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M468.59 277.97l.63 3.11h-2.62v-3.11h1.99z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M464.61 277.97l-.63 3.11h2.62v-3.11h-1.99z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M466.6 261.95l-12.52 17.1 8.18-2.09 4.34 1.86v-16.87z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M466.6 256.39l-10.55 14.42 6.9-1.76 3.65 1.56v-14.22z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M466.6 252.61l-7.87 10.76 5.14-1.32 2.73 1.17v-10.61z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M466.6 261.95l12.52 17.11-8.19-2.1-4.33 1.86v-16.87z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M466.6 256.4l10.55 14.41-6.9-1.76-3.65 1.56V256.4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M466.6 252.62l7.87 10.75-5.15-1.31-2.72 1.16v-10.6z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M381.13 271.13l.63 3.11h-2.62v-3.11h1.99z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M377.15 271.13l-.63 3.11h2.62v-3.11h-1.99z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M379.14 255.1l-12.52 17.11 8.18-2.09 4.34 1.86V255.1z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M379.14 249.55l-10.55 14.42 6.9-1.76 3.65 1.56v-14.22z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M379.14 245.77l-7.87 10.76 5.14-1.32 2.73 1.17v-10.61z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M379.14 255.11l12.52 17.11-8.19-2.1-4.33 1.86v-16.87z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M379.14 249.56l10.55 14.41-6.9-1.76-3.65 1.56v-14.21z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M379.14 245.78l7.87 10.75-5.15-1.31-2.72 1.16v-10.6z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M440.02 274.1l.71 3.53h-2.96v-3.53h2.25z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M435.52 274.1l-.71 3.53h2.96v-3.53h-2.25z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M437.77 255.98l-14.15 19.35 9.25-2.36 4.9 2.1v-19.09z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M437.77 249.7l-11.92 16.31 7.79-2 4.13 1.77V249.7z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M437.77 245.42l-8.89 12.17 5.81-1.49 3.08 1.32v-12z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M437.77 255.98l14.15 19.36-9.25-2.37-4.9 2.1v-19.09z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M437.77 249.7l11.92 16.31-7.79-1.99-4.13 1.77V249.7z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M437.77 245.43l8.89 12.16-5.81-1.49-3.08 1.32v-11.99z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M589.5 321.14l73.84-18.78 32.11 3.71 32.2-13.89 35.32-2.01 18.08-10.15 11.72.55 2.96-.6 5.4-5.61 18.97 2.36 37.65 10.57 19.46 7.52 14.08-3 10.25.48 14.54 2.88 7.84 4.78 21.93 1.76 20.71-3.43 43.68 7.2 23.92 6.26 30.82-.02 26.87-9.74 26.07-8.31 33.68 1.58 15.19-11.02 18.65-6.46 14.15-4.47 11.32-6.81 22.14-2.62 27.82 1.31 15.54-2.94 26.08-8.31 23.46.37 6.41 3.97 19.7 2.39 15.37.73 15.21 4.38 23.91 6.26 2.2.11 18.16 3.79 7.39-1.12 18.06-9.43 26.94-11.2 4.56-3.46 37.37-14.38 13.55-7.43 18.09 7.13 47.9-6.23 6.39 4.71 17.88 9.64 29.01 7.24 5.62 5.4 27.13 15.95 5.2 14.18 19.42 8.25 12.8 8.68 12.03 9.37 14.2 10.2 21.1 19.34-189.96 60.76-770.65 20.97L589.5 321.14z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M3996.26 286.83s-78.86-.86-202.66 7.98c-139.67 9.98-337.04 46.4-417.7 55.11l-.3.03h-.11l-10.49 1.14c-82.36 8.91-172.61 16.04-256.29 21.2-49.78 3.07-99.73 5.45-148.45 7.07-53.74 1.79-107.2 2.7-158.91 2.7-30.6 0-61.23-.32-91.04-.95-31.14-.65-62.23-1.67-92.41-3.01-31.49-1.4-62.83-3.19-93.14-5.33-31.57-2.22-62.94-4.88-93.22-7.9-66.75-6.65-135.7-12.95-204.94-18.71-64.48-5.38-189.04-13.24-238.65-15.04-47.64-2.12-97.99 0-97.99 0-33.1 1.79-116.18 9.65-159.21 15.03-46.18 5.77-92.19 12.06-136.71 18.71-20.21 3.02-41.13 5.68-62.19 7.91-20.23 2.13-41.14 3.93-62.14 5.33-20.13 1.34-40.88 2.35-61.65 3-19.89.63-40.32.95-60.73.95-34.49 0-70.17-.91-106.01-2.7-32.5-1.62-65.82-4-99.03-7.07-55.82-5.16-111.98-12.29-166.92-21.2l-6.99-1.13h-.08l-.2-.04c-53.8-8.71-114.78-18.57-177.52-28.25-72.23-11.14-135.15-20.24-192.36-27.81-33.44-4.42-65.5-8.39-95.27-11.8-32.3-3.69-63.02-6.85-91.29-9.38-30.32-2.71-58.83-4.79-84.73-6.19-27.54-1.48-53-2.24-75.64-2.24-24.05 0-45.66.85-64.27 2.51a708.474 708.474 0 00-35.48 4.1 680.417 680.417 0 00-33.99 5.72 661.741 661.741 0 00-63.56 15.7c-18.05 5.44-37.57 12.35-55.08 19.35l-.17 137.46 1930.33-1h.13l2067.03.71.03-161.97z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1293.09 381.39l1.04 5.52h-4.33v-5.52h3.29z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1286.52 381.39l-1.05 5.52h4.33v-5.52h-3.28z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1289.8 353.07l-20.69 30.25 13.53-3.7 7.16 3.28v-29.83z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1289.8 343.26l-17.44 25.48 11.41-3.11 6.03 2.76v-25.13z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1289.8 336.58l-13 19 8.5-2.32 4.5 2.06v-18.74z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1289.8 353.08l20.7 30.24-13.53-3.7-7.17 3.28v-29.82z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1289.8 343.26l17.44 25.49-11.4-3.12-6.04 2.77v-25.14z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1289.8 336.58l13.01 19.01-8.5-2.32-4.51 2.06v-18.75z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1258.52 381.72l.81 3.97H1256v-3.97h2.52z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1253.47 381.72l-.81 3.97h3.34v-3.97h-2.53z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1256 361.35l-15.93 21.76 10.41-2.66 5.52 2.36v-21.46z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1256 354.29l-13.42 18.33 8.77-2.24 4.65 1.99v-18.08z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1256 349.49l-10.01 13.67 6.54-1.67 3.47 1.48v-13.48z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1256 361.36l15.92 21.75-10.41-2.66-5.51 2.36v-21.45z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1256 354.3l13.41 18.33-8.77-2.24-4.64 1.99V354.3z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1256 349.49l10 13.67-6.54-1.67-3.46 1.48v-13.48z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1331 383.6l.8 3.96h-3.33v-3.96h2.53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1325.94 383.6l-.8 3.96h3.33v-3.96h-2.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1328.47 363.22l-15.92 21.76 10.41-2.66 5.51 2.36v-21.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1328.47 356.16l-13.42 18.34 8.78-2.25 4.64 1.99v-18.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1328.47 351.36l-10.01 13.67 6.55-1.67 3.46 1.48v-13.48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1328.47 363.23l15.92 21.75-10.41-2.66-5.51 2.36v-21.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1328.47 356.17l13.42 18.33-8.77-2.24-4.65 1.99v-18.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1328.47 351.36l10.01 13.68-6.54-1.68-3.47 1.49v-13.49z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1203.93 376.24l.63 3.12h-2.62v-3.12h1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199.95 376.24l-.63 3.12h2.62v-3.12h-1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1201.94 360.22l-12.52 17.11 8.19-2.1 4.33 1.86v-16.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1201.94 354.67l-10.55 14.41 6.9-1.76 3.65 1.56v-14.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1201.94 350.89l-7.87 10.75 5.15-1.32 2.72 1.17v-10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1201.94 360.22l12.52 17.11-8.18-2.09-4.34 1.85v-16.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1201.94 354.67l10.55 14.42-6.89-1.77-3.66 1.57v-14.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1201.94 350.89l7.87 10.75-5.14-1.31-2.73 1.16v-10.6z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1166.86 375.85l.54 2.63h-2.21v-2.63h1.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1163.51 375.85l-.54 2.63h2.22v-2.63h-1.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1165.19 362.33l-10.57 14.44 6.91-1.77 3.66 1.57v-14.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1165.19 357.64l-8.91 12.17 5.82-1.49 3.09 1.32v-12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1165.19 354.45l-6.65 9.08 4.35-1.11 2.3.98v-8.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1165.19 362.33l10.56 14.44-6.91-1.77-3.65 1.57v-14.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1165.19 357.64l8.9 12.17-5.82-1.49-3.08 1.32v-12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1165.19 354.46l6.64 9.07-4.35-1.11-2.29.98v-8.94z"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M720.17 308.65s87 10.75 98 11.75 42 3.5 49.5 3.5 15 3.5 25.5 6.5 32 4.5 38.5 6 57 11 60.5 12 9.77 4.78 9.77 4.78l13.92 1.96s-1.69-3.24 13.31-2.74 31 2.5 35 1.5 24 6 29 7 44.5 6.5 46 8.5-25.5 7.5-32.5 7-29.5-2-33-.5-47.5 6-53 7.5-31 2-46 1-81-5-85-5.5-96-26.5-106-29-51.17-23.67-56.17-26.17-33.5-16.17-28-17.67c3.33 0 13.67 1.58 20.67 2.58z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1479.45 379.28l.63 3.12h-2.62v-3.12h1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1475.48 379.28l-.64 3.12h2.62v-3.12h-1.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1477.46 363.26l-12.52 17.11 8.19-2.09 4.33 1.86v-16.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1477.46 357.71l-10.55 14.42 6.9-1.76 3.65 1.56v-14.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1477.46 353.93l-7.87 10.76 5.15-1.32 2.72 1.17v-10.61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1477.46 363.27l12.53 17.11-8.19-2.1-4.34 1.86v-16.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1477.46 357.72l10.56 14.41-6.9-1.76-3.66 1.56v-14.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1477.46 353.94l7.87 10.75-5.14-1.32-2.73 1.17v-10.6z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M802.42 328.6l.63 3.12h-2.62v-3.12h1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798.44 328.6l-.63 3.12h2.62v-3.12h-1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M800.43 312.58l-12.52 17.11 8.18-2.1 4.34 1.86v-16.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M800.43 307.03l-10.55 14.41 6.89-1.76 3.66 1.56v-14.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M800.43 303.25L792.56 314l5.14-1.32 2.73 1.17v-10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M800.43 312.58l12.52 17.11-8.19-2.09-4.33 1.85v-16.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M800.43 307.03l10.55 14.42-6.9-1.77-3.65 1.57v-14.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M800.43 303.25L808.3 314l-5.15-1.31-2.72 1.16v-10.6z"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1015.86 355.15s7.58 3.66 25.15 16.51c17.09 13.72 16.71 24.8.15 46.21-10.52 16.71 25.92 30.33 25.92 30.33s-23.32 1.09-28.89 0-27.13-.19-27.13-.19-8.99-11.92-7.35-26.69c1.64-14.77 35.35-23.37 28.23-38.58-7.12-15.21-30-29.54-30-29.54l13.92 1.96z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M327.84 264.4s28-.33 31-.33 35 3.33 40 3.33 29 .67 30.67 1 21.67 4.67 24.67 4.67 27.67 4.33 27.67 4.33-4.67 2.67-11.33 3c-6.67.33-27.67-.67-29.33.33-1.67 1-22.67 6.67-36 5-13.33-1.67-33.33-6.33-40-8.33s-15.33-7.33-19.67-8.33c-4.33-1-16.67-3-17.67-4.67zM342.67 284.9s15 1 18.5 3 15.5 3 16.5 4.5-10.5 3.5-19 3.5-25-1.5-30-2.5-15-5.5-8-6.5 22-2 22-2zM315.84 277.07s5.5 3 10.5 2 9.67-2.17 10.83-2.33 1.83-2.17-8.67-2.67-23.33-1-12.67 3zM436.9 294.37s38.91.25 67.27 1.28 41.42 4.12 77 8.25 104.78 26.56 108.91 28.62c30.04 9.67-85.08 10.31-100.03 10.31s-80.95 6.7-105.19 6.19c-24.23-.52-80.44-28.88-88.17-33-7.73-4.13-9.8-19.08 40.22-21.66z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M416.33 302.71l.54 2.64h-2.21v-2.64h1.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.98 302.71l-.54 2.64h2.22v-2.64h-1.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M414.66 289.19l-10.57 14.44 6.91-1.76 3.66 1.56v-14.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M414.66 284.51l-8.91 12.17 5.82-1.49 3.09 1.32v-12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M414.66 281.32l-6.65 9.07 4.35-1.11 2.3.99v-8.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M414.66 289.2l10.56 14.44-6.91-1.77-3.65 1.57V289.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M414.66 284.51l8.9 12.17-5.82-1.49-3.08 1.32v-12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M414.66 281.32l6.64 9.08-4.35-1.11-2.29.98v-8.95z"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1148.67 399.4s49.36.67 68.18.83c18.82.17 69.82 11.17 79.82 12.67s-77 7.5-96 6.5-64-13.5-69.5-15 .5-4.5 17.5-5zM1247.17 388.07s35.67 8 47.67 7.67c12-.33 40-2.33 48.33-4.33 8.33-2 57 6.33 67.67 2.33 10.67-4 37.33-7 42-10.33 4.67-3.33 12.67-4.67 12.67-6s-15.46-.37-17.08-.25-54.5 2.37-60.12 2.25c-5.62-.12-61.5.37-67.5 0s-72.62-2-84.29-3c-11.67-1-33.04-1.46-35.62-1.67-2.33.08 2.12 2.42 9.37 3.37 7.33.67 31.92 9.46 36.92 9.96z"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1360.54 396.79l.63 3.12h-2.62v-3.12h1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1356.56 396.79l-.63 3.12h2.62v-3.12h-1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1358.55 380.77l-12.52 17.11 8.19-2.09 4.33 1.86v-16.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1358.55 375.22L1348 389.64l6.9-1.76 3.65 1.56v-14.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1358.55 371.44l-7.87 10.76 5.15-1.32 2.72 1.17v-10.61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1358.55 380.78l12.52 17.11-8.18-2.1-4.34 1.86v-16.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1358.55 375.23l10.55 14.41-6.9-1.76-3.65 1.56v-14.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1358.55 371.45l7.87 10.75-5.14-1.32-2.73 1.17v-10.6z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1398.73 385.77l.63 3.12h-2.62v-3.12h1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1394.75 385.77l-.63 3.12h2.62v-3.12h-1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1396.74 369.75l-12.52 17.1 8.19-2.09 4.33 1.86v-16.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1396.74 364.19l-10.55 14.42 6.9-1.76 3.65 1.56v-14.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1396.74 360.42l-7.87 10.75 5.15-1.32 2.72 1.17v-10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1396.74 369.75l12.52 17.11-8.19-2.09-4.33 1.85v-16.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1396.74 364.2l10.55 14.42-6.9-1.77-3.65 1.57V364.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1396.74 360.42l7.87 10.75-5.15-1.31-2.72 1.16v-10.6z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1228.41 404.18l.96 4.75h-3.99v-4.75h3.03z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1222.35 404.18l-.96 4.75h3.99v-4.75h-3.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1225.38 379.77l-19.08 26.07 12.47-3.19 6.61 2.82v-25.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1225.38 371.31l-16.08 21.97 10.51-2.69 5.57 2.38v-21.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1225.38 365.55l-11.99 16.39 7.84-2.01 4.15 1.78v-16.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1225.38 379.78l19.07 26.06-12.47-3.19-6.6 2.83v-25.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1225.38 371.32l16.07 21.96-10.51-2.68-5.56 2.38v-21.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1225.38 365.56l11.99 16.38-7.84-2-4.15 1.78v-16.16z"
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1548.17 368.4s69.5-11 91-15.5 62.5-9 76-9 37.5-3 39-2.5-10.5 4.5-25 8.5-42.5 17.5-57 22-59.62 14.25-75.62 12.75c-16-1.5-51.12-5.5-58.62-6.5s-16.12-4-16.5-6c-.5-1.5 12.25-1.5 26.75-3.75zM1689.17 397.4s29-6 39.5-5 29.5 4.5 24 5.5-31.5 8-49 7.5-34-3-36.5-3.5 8.5-4.5 22-4.5z"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M678.74 344.57l.8 3.97h-3.33v-3.97h2.53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.68 344.57l-.8 3.97h3.33v-3.97h-2.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M676.21 324.2l-15.92 21.76 10.41-2.66 5.51 2.36V324.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M676.21 317.14l-13.42 18.34 8.77-2.25 4.65 1.99v-18.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M676.21 312.34l-10.01 13.67 6.54-1.67 3.47 1.48v-13.48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M676.21 324.21l15.92 21.75-10.41-2.66-5.51 2.36v-21.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M676.21 317.15l13.42 18.33-8.78-2.24-4.64 1.99v-18.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M676.21 312.34l10.01 13.68-6.55-1.68-3.46 1.49v-13.49z"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M725.34 350.24s28.5 2 38 3 19.5 8.5 10.5 8.5-38 9-53 6-31.5-6.5-27-11 18.5-7.5 31.5-6.5z"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M734.57 353.77l1.32 6.54h-5.49v-6.54h4.17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.23 353.77l-1.32 6.54h5.49v-6.54h-4.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M730.4 320.19l-26.25 35.86 17.17-4.39 9.08 3.89v-35.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M730.4 308.55l-22.12 30.22 14.47-3.7 7.65 3.28v-29.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M730.4 300.63l-16.49 22.54 10.78-2.76 5.71 2.45v-22.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M730.4 320.2l26.25 35.86-17.16-4.39-9.09 3.89V320.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M730.4 308.56l22.12 30.22-14.46-3.7-7.66 3.28v-29.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M730.4 300.64l16.5 22.54-10.79-2.76-5.71 2.44v-22.22z"
  }))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1487.5 254.4l20-5.66 24.67-10 17 5.66 51.33-8.33 22 14.33 26.67 19 24 4 12.33 14.34-16.66-11-31 1-18.34-7.67-12.66-11-18.67 1-13.67-3.67-14 4-11.33.34-18.33 10.66-4 6.67.66-8.67 4.67-9.66-12.67-2-21.33 1.66-10.67-5zM1602.67 296.4l25.5 2 23 6.5 18 14-27.5-5-24.5-10.5-32.5-2 18-5zM1272.67 267.9l33-6.5 49.5 4 35 8.5 23.5 3.5-30.5 3-30.5-3.5-25 5.5-20 2-16-8.5-21 2-14 4 16-14zM802.17 278.4l17 2 46 15-28.5-1-26.5-5-17.5 3.5-14-2.5-20.5 8 24.5-14.5 13 1 6.5-6.5zM955.42 304.65l19-.5 53 10 41.5 2 52.5-16.5 24 1-16.5 13-40.5 5-17.5 6.5h-42.5l-52.5-16-20.5-4.5zM492.24 278.73l43.34 4.55 54.53 7.1 29.19 4.15-21.23 1.13-48.21-.88s-26-7.69-35.85-8.81-21.77-7.23-21.77-7.23z"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M545.55 301.03l.63 3.12h-2.62v-3.12h1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.58 301.03l-.64 3.12h2.62v-3.12h-1.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M543.56 285.01l-12.52 17.11 8.19-2.1 4.33 1.86v-16.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M543.56 279.46l-10.55 14.41 6.9-1.76 3.65 1.56v-14.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M543.56 275.68l-7.87 10.75 5.15-1.32 2.72 1.17v-10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M543.56 285.01l12.53 17.11-8.19-2.09-4.34 1.85v-16.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M543.56 279.46l10.56 14.42-6.9-1.77-3.66 1.57v-14.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M543.56 275.68l7.87 10.75-5.14-1.31-2.73 1.16v-10.6z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M506.59 303.75l1.04 5.09h-4.28v-5.09h3.24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.1 303.75l-1.03 5.09h4.28v-5.09h-3.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M503.35 277.58l-20.46 27.95 13.38-3.42 7.08 3.03v-27.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M503.35 268.51l-17.24 23.55 11.27-2.88 5.97 2.56v-23.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M503.35 262.34l-12.86 17.56 8.41-2.14 4.45 1.9v-17.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M503.35 277.59l20.45 27.94-13.37-3.42-7.08 3.04v-27.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M503.35 268.52l17.23 23.55-11.27-2.88-5.96 2.55v-23.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M503.35 262.35l12.85 17.56-8.4-2.15-4.45 1.91v-17.32z"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1408.67 288.9s-36.5 10-38 10.5-23 15-29 17-27.5 11.5-27.5 11.5l29-6.5 24.5-9 23-1.5 15-4 28 2s30 12.5 36 14 41 6 41 6l23.5-1.5s-37-6-39.5-7-34.5-21.5-34.5-21.5l-24.5-5-11-9-16 4zM454.5 231.74l19.67-8.34 11-9.33 15 3.67 10.67 7.33-1.67-7.33 9-2 18.67 22 21 15-36.34-14.34-21.33-2-12.67-7-14.66 3.34-18.34-1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveMountainComplex);
export default __webpack_public_path__ + "static/media/waveMountainComplex.7c77246556bc6efe5322b2166aa0ad1d.svg";
export { ForwardRef as ReactComponent };